// this is the type of the data that is loaded from the mf files api or by opening the file
export interface AllSheetDataProps {
  sheetName: string;
  sheetData: any[];
  sheetIndex: number;
  sheetId: string;
  isViewReport?: boolean;
}

export interface SheetDataStateProps {
  sheetMemoryData: AllSheetDataProps[];
  arrangeListData: ColumnItem[];
  columnHeaders: string[];
  allSheetData: AllSheetDataProps[];
  isLoader: boolean;
  isError: boolean;
  errorMessage: string;
}
export const sheetDataState: SheetDataStateProps = {
  sheetMemoryData: [],
  arrangeListData: [],
  allSheetData: [],
  columnHeaders: [],
  isLoader: false,
  isError: false,
  errorMessage: '',
};
